import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button/Button';
import Market from '@/components/ResourcesSidebar/Market';
import GameFamily from '@/components/ResourcesSidebar/GameFamily';
import GameStatus from '@/components/ResourcesSidebar/GameStatus';
import GameFeature from '@/components/ResourcesSidebar/GameFeature';
import GameGroup from '@/components/ResourcesSidebar/GameGroup';
import ReleaseDate from '@/components/ResourcesSidebar/ReleaseDate';
import { FilterSchema } from '@/components/ResourcesSidebar/ResourcesSidebarHelpers';

const InitialState = {
  market: [],
  fileFormatMarketing: [],
  gameFamily: [],
  gameStatus: [],
  gameFeatures: [],
  gameGroups: [],
  releaseDate: [],
};

const FileExplorerMarketingFilters = ({
  filters,
  onFiltersChange,
}: {
  filters: Partial<FilterSchema>;
  onFiltersChange: (filters: Partial<FilterSchema>) => void;
}) => {
  const handleClearAll = () => {
    onFiltersChange(InitialState);
  };

  const handleChange = (
    key: keyof FilterSchema,
    value: string[] | number[],
  ) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  return (
    <Root>
      <Header>
        <FormattedMessage id="filterBy" defaultMessage="Filter By" />
        <Button
          variant="text"
          customVariant="text-small"
          onClick={handleClearAll}
          aria-label="Clear All Button"
        >
          <FormattedMessage
            id="clearAll"
            defaultMessage="Clear All"
          />
        </Button>
      </Header>
      <Market
        value={
          filters.market && filters.market.length > 0
            ? filters.market[0]
            : null
        }
        onChange={(value) =>
          handleChange('market', value !== null ? [value] : [])
        }
      />
      <GameFamily
        value={filters.gameFamily || InitialState.gameFamily}
        onChange={(value) => handleChange('gameFamily', value)}
      />
      <GameStatus
        value={filters.gameStatus || InitialState.gameStatus}
        onChange={(value) => handleChange('gameStatus', value)}
      />
      <GameFeature
        value={filters.gameFeatures || InitialState.gameFeatures}
        onChange={(value) => handleChange('gameFeatures', value)}
      />
      <GameGroup
        value={filters.gameGroups || InitialState.gameGroups}
        onChange={(value) => handleChange('gameGroups', value)}
      />
      <ReleaseDate
        value={filters.releaseDate || InitialState.releaseDate}
        onChange={(value) => handleChange('releaseDate', value)}
      />
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  width: 240,
  height: '100%',
  maxHeight: '400px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.radii.xs,
  backgroundColor: theme.palette.white,
  padding: '16px 12px',
  boxShadow:
    '0px 10px 32px -4px #1319271A, 0px 6px 14px -6px #1319271F',
}));

const Header = styled('div')(() => ({
  fontSize: 16,
  lineHeight: '24px',
  fontWeight: 500,
  padding: '4px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export default FileExplorerMarketingFilters;
